import { connect } from "react-redux";
import FdesPage from "../pages/Fdes";
import {
  loadFdesParameters,
  saveFdesForm,
  saveFdesRealTimeForm,
  loadReference,
  saveFdesResult,
  updateCalcul,
  cleanNameForm,
  upgradeCalcul,
  getFdesMetaData,
  generateReports,
  changeSimulationMode,
} from "../actions";
import { getFdesFormIsEdited } from "../selectors";
import { getCalcul, clearCalcul } from "../../calcul/actions";
import { getLocalEDECIntegration } from "../../../modules/user/actions";

export default connect(
  (state) => ({
    user: state.user.informations,
    familyProducts: state.familyProduct.familyProducts,
    isGeneratingReports: state.loader.isGeneratingReports,
    calculIsLoading: state.loader.calculIsLoading,
    formIsLoading: state.fdes.form.isLoading,
    isEdited: getFdesFormIsEdited(state),
    isSaved: state.fdes.form.isSaved,
    resultFormIsLoading: state.fdes.resultForm.isLoading,
    resultFormIsSaved: state.fdes.resultForm.isSaved,
    metadata: state.fdes.metadata,
    calcul: state.calculs.calcul,
    settings: state.fdes.settings,
    reports: state.calculs.calculReports,
    isFormUpdated: state.fdes.form.isFormUpdated,
    localConfigurator: state.configurator.localConfigurator,
    localEDECIntegration: state.configurator.localEDECIntegration,
    fdesParameters: state.fdes.fdesParameters,
  }),
  (dispatch) => ({
    loadFdesParameters: (fdesId, api, calcul, isEditMode) => {
      dispatch(loadFdesParameters(fdesId, api, calcul, isEditMode));
    },
    saveFdesForm: (fdesId) => {
      dispatch(saveFdesForm(fdesId));
    },
    saveFdesRealTimeForm: (api, fdesId) => {
      dispatch(saveFdesRealTimeForm(api, fdesId));
    },
    loadReference: (standard) => {
      dispatch(loadReference(standard));
    },
    saveFdesResult: () => {
      dispatch(saveFdesResult());
    },
    generateReports: (filesToGenerate, userFdesId) => {
      dispatch(generateReports(filesToGenerate, userFdesId));
    },
    updateCalcul: (calculId) => {
      dispatch(updateCalcul(calculId));
    },
    cleanNameForm: () => {
      dispatch(cleanNameForm());
    },
    onUpgradeCalcul: (calculId) => {
      dispatch(upgradeCalcul(calculId));
    },
    getFdesMetadata: (fdesId) => {
      dispatch(getFdesMetaData(fdesId));
    },
    getCalcul: (calculId) => {
      dispatch(getCalcul(calculId));
    },
    clearCalcul: () => {
      dispatch(clearCalcul());
    },
    getLocalEDECIntegration: () => {
      dispatch(getLocalEDECIntegration());
    },
    onChangeSimulationMode: (value) => {
      dispatch(changeSimulationMode(value));
    },
  }),
)(FdesPage);
